import SubmissionError from '../../../error/SubmissionError';
import http from '../../../utils/http';
import security from '../../../utils/security';
import {
  AGREEMENT_CREATE_ERROR,
  AGREEMENT_CREATE_LOADING,
  AGREEMENT_CREATE_SUCCESS,
  AGREEMENT_CREATE_VIOLATIONS,
  AGREEMENT_CREATE_RESET
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  created: null,
  violations: {}
};

function error(error) {
  return {type: AGREEMENT_CREATE_ERROR, error};
}

function loading(loading) {
  return {type: AGREEMENT_CREATE_LOADING, loading};
}

function success(created) {
  return {type: AGREEMENT_CREATE_SUCCESS, created};
}

function violations(violations) {
  return {type: AGREEMENT_CREATE_VIOLATIONS, violations};
}

function reset() {
  return {type: AGREEMENT_CREATE_RESET};
}

const getters = {
  created: state => state.created,
  error: state => state.error,
  loading: state => state.loading,
  violations: state => state.violations,
};

const actions = {
  create({ commit }, values) {
    commit(loading(true));
    commit(violations({}));
    commit(error(null));
    if(typeof values.commission == 'string'){
      values.commission = values.commission.replace(',','.').replace(' ','');
    }
    values.commission = parseFloat(values.commission);

    return http.fetch('/agreements', {method: 'POST', body: JSON.stringify(values)})
      .then(response => {
        commit(loading(false));

        return response.json();
      })
      .then(data => {
        commit(success(data));
        return true;
      })
      .catch(e => {
        commit(loading(false));
        if(security.handleAuthorizationError(e)){
          return false;
        }
        if (e instanceof SubmissionError) {
          commit(violations(e.errors));
          return false;
        }

        commit(error(e.message));
        return false;
      });
  },
  reset({ commit }) {
    commit(reset());
  }
};

const mutations = {
    [AGREEMENT_CREATE_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [AGREEMENT_CREATE_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [AGREEMENT_CREATE_SUCCESS] (state, payload) {
      state.created = payload.created;
    },
    [AGREEMENT_CREATE_VIOLATIONS] (state, payload) {
      state.violations = payload.violations;
    },
    [AGREEMENT_CREATE_RESET] (state) {
      state.loading = false;
      state.error = '';
      state.created = null;
      state.violations = null;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/agreement/create.js